import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MJAuthBase } from '@memberjunction/ng-auth-services';
import { UserAuthService } from '../../services/user-auth.service';
import { LogStatus } from '@memberjunction/core';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss']
})
export class NoAccessComponent implements OnInit {
  isNoAccessRole: boolean = false;
  isCheckingAccess: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authBase: MJAuthBase,
    private userAuthService: UserAuthService
  ) {}

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(params => {
      this.isNoAccessRole = params['reason'] === 'no-access-role';
    });

    // Re-check access on page load (in case role changed in backend)
    await this.recheckAccess();
  }

  /**
   * Re-fetch role from API to check if user now has access
   */
  async recheckAccess(): Promise<void> {
    try {
      this.isCheckingAccess = true;
      LogStatus('NoAccessComponent: Re-checking user access...');

      const personId = this.userAuthService.getPersonId();
      const auraUniqueId = this.userAuthService.getAuraUniqueId();

      if (personId && auraUniqueId) {
        // Clear role cache to force fresh fetch
        this.userAuthService.clearRoleCache();

        // Fetch fresh role from API
        const role = await this.userAuthService.fetchUserRole(personId, auraUniqueId);
        LogStatus(`NoAccessComponent: Fresh role fetched: ${role}`);

        // If role is no longer "No Access", redirect to dashboard
        if (role && role !== 'No Access') {
          LogStatus('NoAccessComponent: User now has access, redirecting to dashboard');
          await this.router.navigate(['/dashboard']);
        }
      }
    } catch (error) {
      LogStatus('NoAccessComponent: Error re-checking access, staying on no-access page');
    } finally {
      this.isCheckingAccess = false;
    }
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  async logout(): Promise<void> {
    await this.authBase.logout();
  }
}